import { render, staticRenderFns } from "./headerpanel.vue?vue&type=template&id=51f0eb86&"
import script from "./headerpanel.vue?vue&type=script&lang=js&"
export * from "./headerpanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports